import { jsx as _jsx } from "react/jsx-runtime";
import { useCopyClipboard } from '@layerswap/ui-kit';
import { DepositAddressFormButtonView, } from './DepositAddressFormButtonView';
const DepositAddressFormButton = ({ values, ...props }) => {
    const [copied, copy] = useCopyClipboard();
    return (_jsx(DepositAddressFormButtonView, { ...props, waitingForAddress: !values?.destination_address, copied: copied, onCopy: () => {
            if (props.depositAddress)
                copy(props.depositAddress);
        } }));
};
export default DepositAddressFormButton;
